export const SITE_URL = "https://peptidex.ai";
export const SITE_NAME = "PeptideX";
export const SITE_TITLE = "PeptideX: Peptide and GLP-1 evidence, FDA status and costs";
export const SITE_DESCRIPTION =
  "Plain-language, source-linked guide to peptides and GLP-1 drugs: evidence ratings, FDA status, costs and the retatrutide approval tracker. Education only.";
export const CONTENT_DATE = "October 21, 2026";
export const CONTENT_DATE_ISO = "2026-10-21";
export const NUVOTRIM_URL = "https://nuvotrim.com";
export const TRACKER_OG = `${SITE_URL}/og-tracker.png`;
export const FOOTER_DISCLAIMER =
  "Educational information only, not medical advice. VitalBridge X Holdings, 30 N Gould St, Sheridan, WY 82801.";

export const FDA_UNAPPROVED_DRUGS = "https://www.fda.gov/drugs/enforcement-activities-fda/unapproved-drugs";
export const FDA_GLP1_WARNING =
  "https://www.fda.gov/drugs/drug-alerts-and-statements/fdas-concerns-unapproved-glp-1-drugs-used-weight-loss";
